<template>
    <div>
        <Results_Biomarkers></Results_Biomarkers>

        <div style="padding:20px;">
            <v-btn @click="annotate()">Run annotation</v-btn>
        </div>

        <Variant_Table></Variant_Table>
    </div>
</template>
<script>
import Variant_Table from '@/components/tables_native/Variant_Table.vue'
import variant_annotation from "@/methods/variant_annotation";

export default {
    name: 'ShowIDVariants',
    components: {
        Variant_Table
    },
    async mounted() {
    },
    methods: {
        async annotate() {
        let data_dir="loc"
            await variant_annotation.analyzeVariantsSequential(this.$route, data_dir=data_dir)
            this.$store.dispatch('setBackRef',this.$route.fullPath)
        }
    }
}
</script>
